module.exports = __webpack_public_path__ + "files/16e5d6ec516605c4ff3cf11dd499cb8b.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/pt_sans-web-bolditalic-webfont.ttf
// module id = 747
// module chunks = 60